import { ApiIncidentType, ApiPageType } from "@store/types";
import useSWR from "swr";
import { fetcher } from "../model/fetcher";

export const useUnresolvedIncidents = <T>(
    comparator: (a: T, b: T) => number,
    mapper: (incident: ApiIncidentType, index: number) => T,
) => {
    const { data, error } = useSWR<{ incidents: ApiIncidentType[]; page: ApiPageType }>(
        "/incidents/unresolved.json",
        fetcher,
        {
            refreshInterval: 3000,
        },
    );

    const incidents = (data?.incidents ?? []).map(mapper).sort(comparator);

    return { incidents, error };
};
